import { Button, ButtonProps, Popconfirm } from "antd";
import { PopconfirmProps } from "antd/lib/popconfirm";
import { CorrecaoContabil } from "../../../../../Models/Domain/Viagem/Financeiro/CorrecaoContabil";
import { useCorrecaoContabilDesativar } from "../../../../../Services/Domain/Viagem/Financeiro/CorrecaoContabilServices";import { EditOutlined } from "@ant-design/icons";
import { DeleteOutlined } from "@ant-design/icons";
interface ICorrecaoContabilDesativarPopConfirmProps extends Partial<PopconfirmProps> {
    correcaoContabil:CorrecaoContabil;
    buttonProps?:ButtonProps;
}
export default function CorrecaoContabilDesativarPopConfirm({
    correcaoContabil,
    buttonProps,
    ...props
}:ICorrecaoContabilDesativarPopConfirmProps) {
    buttonProps = buttonProps ?? {};
    buttonProps.danger = buttonProps.danger ?? true;

    const {
        mutate,
        isPending
    } = useCorrecaoContabilDesativar({

    });

    return <Popconfirm
        title={"Remover ajuste"}
        description={"Tem certeza que deseja remover este ajuste?"}
        onConfirm={() => mutate(correcaoContabil)}
        okButtonProps={{
            loading : isPending
        }}
        {...props}
    >
        <Button {...buttonProps}>
            {buttonProps.children ?? <DeleteOutlined />}
        </Button>
    </Popconfirm>
}